import * as React from "react"
import { useColorScheme, ViewStyle } from "react-native"
import { Route, TabBar as TabBarBase, TabBarProps as TabBarPropsBase } from "react-native-tab-view"
import { color, nativeBaseTheme } from "../../theme"
import { Text } from "../text/text"
import { Scene } from "react-native-tab-view/lib/typescript/types"

const TAB: ViewStyle = {
  width: 'auto',
  paddingHorizontal: 16,
  paddingVertical: 8
}

export interface TabBarProps<T extends Route> extends Omit<TabBarPropsBase<T>,"getLabelText"|"getAccessible"|"getAccessibilityLabel"|"getTestID"|"renderIndicator"> {
  getLabelText?: (scene: Scene<T>) => string | undefined;
  getAccessible?: (scene: Scene<T>) => boolean | undefined;
  getAccessibilityLabel?: (scene: Scene<T>) => string | undefined;
  getTestID?: (scene: Scene<T>) => string | undefined;
  renderLabel?: (scene: Scene<T> & {
    focused: boolean;
    color: string;
  }) => React.ReactNode;

  colorScheme?: "light" | "dark"
}

/**
 * Describe your component here
 */
export const TabBar = function TabBar(props: TabBarProps<any>) {
  const { colorScheme = useColorScheme(), ...rest } = props

  const style = [{ backgroundColor: nativeBaseTheme.colors[colorScheme]["50"] }]
  const tabIndicatorStyle = [{ backgroundColor: colorScheme === 'light' ? color.primary : nativeBaseTheme.colors.light["50"] }]

  return (
    <TabBarBase
      renderLabel={({ route, color, focused }) => (
        <Text text={route.title} preset="title4" colorScheme={colorScheme} color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]} />
      )}
      style={style}
      tabStyle={TAB}
      indicatorStyle={tabIndicatorStyle}
      activeColor={colorScheme === 'light' ? color.primary : undefined}
      scrollEnabled
      {...rest}
    />
  )
}
